import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';
import ToolCard from '../components/ToolCard';

export default function Dashboard() {
  const { user } = useAuth();
  const [tools, setTools] = useState([]);
  const [health, setHealth] = useState({});
  const [loading, setLoading] = useState(true);
  const [ranking, setRanking] = useState([]);
  const [personalBest, setPersonalBest] = useState(0);

  useEffect(() => {
    Promise.all([
      api.get('/tools'),
      api.get('/tools/health').catch(() => []),
      api.get('/arcade/leaderboard/montaje?limit=5').catch(() => ({ leaderboard: [], personalBest: 0 })),
    ]).then(([toolsData, healthData, arcadeData]) => {
      setTools(toolsData);
      const hm = {};
      if (Array.isArray(healthData)) {
        healthData.forEach(h => { hm[h.tool_id] = h.status; });
      }
      setHealth(hm);
      setRanking(arcadeData.leaderboard || []);
      setPersonalBest(arcadeData.personalBest || 0);
    }).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="text-center py-12 text-gray-500">Cargando herramientas...</div>;
  }

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900">Hola, {user?.name}</h2>
        <p className="text-sm text-gray-500 mt-1">Tus herramientas disponibles</p>
      </div>

      {tools.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-xl">
          <p className="text-gray-400">No tienes herramientas asignadas.</p>
          <p className="text-sm text-gray-300 mt-1">Contacta con el administrador.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tools.map(tool => (
            <ToolCard key={tool.id} tool={tool} health={health[tool.id]} />
          ))}
        </div>
      )}

      {/* Montaje: ranking semanal */}
      <div className="mt-6 rounded-xl p-5 shadow-sm" style={{ backgroundColor: '#0f1117' }}>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md flex items-center justify-center font-bold text-xs" style={{ backgroundColor: '#FFB800', color: '#0f1117' }}>E</div>
            <span className="text-white font-bold text-sm tracking-wide">MONTAJE</span>
            <span className="text-xs" style={{ color: 'rgba(255,255,255,0.35)' }}>ranking de la semana</span>
          </div>
          <a href="/arcade" className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors" style={{ backgroundColor: 'rgba(255,184,0,0.15)', color: '#FFB800' }}>
            Jugar
          </a>
        </div>
        {ranking.length > 0 ? (
          <div className="space-y-2.5">
            {ranking.map((entry, i) => (
              <div key={i} className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <span className="w-5 text-right text-sm font-bold" style={{ color: i === 0 ? '#FFB800' : i === 1 ? '#c0c0c0' : i === 2 ? '#cd7f32' : 'rgba(255,255,255,0.3)' }}>
                    {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `${i + 1}`}
                  </span>
                  <span className="text-white text-sm">{entry.name}</span>
                  {entry.name === user?.name && (
                    <span className="text-xs px-1.5 py-0.5 rounded" style={{ backgroundColor: 'rgba(255,184,0,0.15)', color: '#FFB800' }}>Tú</span>
                  )}
                </div>
                <span className="font-mono font-bold text-sm" style={{ color: '#FFB800' }}>{entry.score}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-4">
            <p className="text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>Nadie ha montado nada esta semana. Estrena el ranking.</p>
          </div>
        )}
        {personalBest > 0 && !ranking.find(r => r.name === user?.name) && (
          <div className="mt-3 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="flex items-center justify-between text-xs" style={{ color: 'rgba(255,255,255,0.4)' }}>
              <span>Tu mejor puntuación</span>
              <span className="font-mono font-bold" style={{ color: '#FFB800' }}>{personalBest}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
